import React, { useCallback, useRef, useState } from 'react';
// import MenuItem from '../components/MenuItem';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import '../App.css';
import PageLoader from '../components/PageLoader';
import { ToastContainer, toast } from 'react-toastify';
import Webcam from "react-webcam";
import Auth from '../core/services/auth';
import { useNavigate } from 'react-router-dom';
// import GoogleMapReact from 'google-map-react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import GooglePlacesAutocomplete, { geocodeByAddress  } from 'react-google-places-autocomplete';
// import Autocomplete from "react-google-autocomplete";


// const AnyReactComponent = ({ text }: any) => <div>{text}</div>;

function Post() {
  // navigate to Login
  const navigate = useNavigate();
  const [ loading, setLoading ] = useState(false);
  
  const [ caption, setCaption ] = useState('')
  // const location = {
  //   "type": "Point",
  //   "coordinates": [5.5522971,-0.2037657]
  // };
  const [value, setValue] = useState<any>();

  const [ openPersonal, setOpenPersonal ] = useState(false)
  // const [ openMap, setOpenMap ] = useState(false)
  
  const downloadRef = useRef<HTMLButtonElement>(null);
  const webcamRef = useRef<any>(null);
  const mediaRecorderRef = useRef<any>(null);
  const [ video, setMedia ] = useState<any>();

  const [ isRecording, setIsRecording ] = useState(false);
  const [ duration, setDuration ] = useState<number>();
  const [ audio, setAudio ] = useState(true)

  // const [ facingMode, setFacingMode ] = useState<any>({
  //   facingMode: { exact: "user" }, 
  // });
  // const [ frameRate, setFrameRate ] = useState<any>({
  //   frameRate: { max: 60 }
  // });

  const [ videoConstraints, setVideoConstrainst ] = useState({
    facingMode: { exact: "user" },
    frameRate: { max: 60 }
  })

  const setAudioVolume = async () => {
    if (audio) {
      
      setAudio(false)
    } 
    
    else {
      setAudio(true)
      //
    }
    
  }

  const switchCamera = () => {
    
    if (videoConstraints.facingMode.exact === "user") {
      
      setVideoConstrainst({
        facingMode: { exact: "environment" },
        frameRate: { max: videoConstraints.frameRate.max }
      })
    } 
    
    else {

      setVideoConstrainst({
        facingMode: { exact: "user" },
        frameRate: { max: videoConstraints.frameRate.max }
      })
    }
    
  }

  const recordVideo = (event:any) => {

    // setInterval(()=>{
    //   setNo((prevCounter)=> prevCounter + 1 )
    // }, 1500)

    //
    if (isRecording) {
      //
      handleStopCaptureClick()

    } else {

      handleStartCaptureClick()
    }
  }

  const switchFrameRate = () => {
    
    if (videoConstraints.frameRate.max === 60) {
      
      setVideoConstrainst({
        facingMode: { exact: videoConstraints.facingMode.exact },
        frameRate: { max: 30 }
      })
    } 
    
    else {
      setVideoConstrainst({
        facingMode: { exact: videoConstraints.facingMode.exact },
        frameRate: { max: 60 }
      })
    }
  }


  const [recordedChunks, setRecordedChunks] = useState([]);

  const handleDataAvailable = React.useCallback(
    ({ data }: any) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStartCaptureClick = useCallback(() => {
    console.log('started recording')
    setIsRecording(true); 

    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm"
    });
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
    
  }, [webcamRef, mediaRecorderRef, handleDataAvailable]);

  const handleStopCaptureClick = useCallback(() => {
    // if (!isRecording) return;
    
    // alert('stopped recording')
    mediaRecorderRef.current.stop();
    
    console.log('stopped recording')
    setIsRecording(false);
    setDuration(Math.random() * 10)
    
    setTimeout(()=>{
      downloadRef.current?.click();
      
    }, 500)
    
    setOpenPersonal(true);
    //

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaRecorderRef, webcamRef, setIsRecording]);

  const handleDownload = useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/webm"
      });

      setMedia(blob)

      console.log(blob)

      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // document.body.appendChild(a);
      // a.className = "invisible";
      // a.href = url;
      // a.download = "react-webcam-stream-capture.webm";
      // a.click();
      // window.URL.revokeObjectURL(url);
      // setRecordedChunks([]);
    }
  }, [recordedChunks]);

    const handleSubmit = (ev: any) => {

      ev.preventDefault()

      setLoading(true)

      const location = {
        "type": "Point",
        "coordinates": [0, 0],
        "name": value.label
      };

      //
      // console.log(value)
      geocodeByAddress(value.label).then(res=>{
        // console.log(res)
        location.coordinates = [ res[0].geometry.location.lat(), res[0].geometry.location.lng()]

        const formData = new FormData()
        formData.append("media", video)
        formData.append("caption", caption)
        formData.append("location", JSON.stringify(location))

        Auth.api.post('/posts', formData).then(res=>{

          setLoading(false)

          //  update
          setTimeout(()=>{
            navigate('/')
          }, 1800)
          

          toast.success(res.data.message, {
            position: "top-center",
          });

        }).catch(err=>{
          console.log(err)

          setLoading(false)

          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
            position: "top-center",
          });
        })

      }).catch(err=>{

        setLoading(false)
        
        console.log(err)
          toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          position: "top-center",
        });
      })
    }

    // const defaultProps = {
    //   center: {
    //     lat: 5.5522971,
    //     lng: -0.2037657
    //   },
    //   zoom: 11
    // };
    // console.log(value)
    // geocodeByAddress(value.label).then(res=>{
    //   console.log(res)
    // }).catch(err=>{
    //   console.log(err)
    // })
    return (
        <section className='h-screen bg-black'>
          <div className='absolute left-5 top-5 z-20 p-5'>
            <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                <button onClick={e=>navigate(-1)} className="items-center">
                  <svg className="w-5 h-5" fill='currentColor' aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                </button>
            </div>
          </div>
          {/* <div className="flex flex-col items-center justify-center mx-auto md:h-screen lg:py-0"> */}
          { loading ? <PageLoader /> : '' }
          <ToastContainer />
  
            {/* <MenuItem /> */}
            {/* </div> */}
          <Webcam  ref={webcamRef} style={{height: "100vh"}} className='object-cover' />
          {/* {JSON.stringify(videoConstraints)} */}
          <div className=''>
            {/*  */}
            <div className=' absolute left-6 top-16 p-5'>
              {isRecording &&
              <div className='transition ease-in-out delay-150 h-7 w-7 text-white text-xxs'>
                <CountdownCircleTimer
                  isPlaying={isRecording}
                  key={duration}
                  size={30}
                  strokeWidth={2}
                  duration={60}
                  colors={['#ff4747', '#F7B801', '#A30000', '#A30000']}
                  colorsTime={[30, 20, 10, 0]}
                  // onUpdate={(remaingTime)=> {
                  //   remaingTime = 50
                  // }}
                  onComplete={handleStopCaptureClick}
                >
                  {({ remainingTime }) => remainingTime}
                </CountdownCircleTimer>
              </div>
}
            </div>
            <div className='absolute right-5 top-5 p-5  z-20'>
                <div className='flex flex-col space-y-3'>
                  <button onClick={e=>switchCamera()}>
                    <svg className="h-7 w-7 text-white focus:text-white/75 hover:text-white/75" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="FlipCameraIosIcon"><path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-8 13c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61m4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2z"></path></svg>
                  </button>
                  {/* <button>
                    <svg className="h-7 w-7 text-white" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="FlashOnIcon"><path d="M7 2v11h3v9l7-12h-4l4-8z"></path></svg>
                    <svg className="h-8 w-8 text-white" fill="currentColor" aria-hidden="true" viewBox="0 0 24 24" data-testid="FlashOffIcon"><path d="M3.27 3 2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73zM17 10h-4l4-8H7v2.18l8.46 8.46z"></path></svg>
                  </button> */}
                  <button onClick={e=>switchFrameRate()}>
                    {videoConstraints.frameRate.max === 60 ?
                      <svg className="h-7 w-7 text-white" fill="currentColor"  focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SixtyFpsIcon"><path d="M19 8v8h-4V8zm0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3m-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8zm-2 5v3H5v-3z"></path></svg>
                    :
                      <svg className="h-7 w-7 text-white" fill="currentColor"  focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThirtyFpsIcon"><path d="M2 5v3h6v2.5H3v3h5V16H2v3h6c1.66 0 3-1.34 3-3v-1.9c0-1.16-.94-2.1-2.1-2.1 1.16 0 2.1-.94 2.1-2.1V8c0-1.66-1.34-3-3-3zm17 3v8h-4V8zm0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3"></path></svg>
                    }
                  </button>
                  <button onClick={e=> setAudioVolume() }>
                    {audio ?
                      <svg className="h-7 w-7 text-white" fill="currentColor"  focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VolumeUpIcon" ><path d="M3 9v6h4l5 5V4L7 9zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77"></path></svg>
                      :
                      <svg className="h-7 w-7 text-white" fill="currentColor" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VolumeOffIcon"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63m2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71M4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9zM12 4 9.91 6.09 12 8.18z"></path></svg>
                    }
                  </button>
                  {/* <span className='text-white'>{iOS() && 'iOS'}</span> */}
                  {/* <span className='text-white'>{isRecording && 'record'}</span> */}
                </div>
            </div>
            
            {/* onMouseEnter={handleStartCaptureClick} onMouseLeave={handleStopCaptureClick} */}
              <button onClick={e=>recordVideo(e)}  className={ isRecording ? 'p-5 pb-7 flex justify-center absolute inset-x-0  z-20 bottom-0 text-yellow-800/100' : 'p-5 pb-7 flex justify-center absolute inset-x-0  z-20 bottom-0 text-white'}>
                <svg className="rounded-full border-2 border-white w-16 h-16 text-white focus:text-white/75 hover:text-yellow-800/100" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CircleIcon"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"></path></svg>
              </button>
           
            <button ref={downloadRef} onClick={handleDownload} className='p-5 pb-7 flex justify-center absolute inset-x-0 top-0'>
                    
            </button>
          </div>
          

          {/* Form Modal */}
          <Dialog open={openPersonal} onClose={setOpenPersonal} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <form onSubmit={handleSubmit} style={{width: '100%'}} className="space-y-4 p-6">
                          <div className='pt-2 px-2  text-left'>
                            <p className='text-sm font-medium'> Post Details</p>
                          </div>
                          <div>
                            <input type="text" minLength={4} name="caption" id="caption" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" autoComplete='false' onChange={ (e) => setCaption(e.target.value) } placeholder="Caption" value={caption } required={true}/>
                          </div>
                          {/* <div className='bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'> */}
                          
                          <GooglePlacesAutocomplete 
                              apiKey='AIzaSyDIz3QGrrutmfxrRrYG7j4HAQ0By581Tgs'
                              selectProps={{
                                value: value,
                                onChange: setValue,
                                styles: {
                                  input: (provided) => ({
                                    ...provided,
                                    // display: 'block',
                                    // paddingTop: '1rem',
                                    // paddingBottom: '1rem', 
                                    // paddingLeft: '1.25rem',
                                    // paddingRight: '1.25rem',
                                    // borderRadius: '0.5rem',
                                    // width: '100%',
                                    // color: '#111827',
                                    // backgroundColor: '#F9FAFB',
                                    // borderColor: '0'
                                  })
                                }
                              }}
                          />
                          {/* </div> */}
                          
                          {/* <Autocomplete
                            className='bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                            apiKey='AIzaSyDIz3QGrrutmfxrRrYG7j4HAQ0By581Tgs'
                            onPlaceSelected={(value) => {
                              console.log(value);
                              setValue(value)
                            }}
                            defaultValue={'Ghana'}
                          /> */}
                          {/* { JSON.stringify(value)} */}
                          {/* <div className="relative z-40" >
                             <input type="text" id="logoText" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"  placeholder="Accra"/>
                              
                          </div> */}
                          {/* <div className="relative z-40">
                             <input type="text" id="logoText" disabled={true} className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={video ? video.name : 'Add Video'}/>
                              <button type='button' onClick={handleLogoClick} className="absolute  inset-y-0 end-0 flex items-center pe-3.5">
                                <svg className="w-7 h-7 text-dark dark:text-gray-400" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="VideocamIcon"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11z"></path></svg>
                             </button>
                          </div> */}
                          {/* <div className='grid grid-cols-3 gap-4'>
                            <div>
                                <input type="text" name="country" id="country" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setCountry(e.target.value) } placeholder="Country" value={country} required={true}/>
                            </div>
                            <div className='col-span-2'>
                                <input type="tel" name="phone" id="phone" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setPhone(e.target.value) } placeholder="Phone" value={phone} required={true}/>
                            </div>
                          </div> */}
                          <div className='w-full  space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Post</button>
                            
                          </div>
                    </form>
                  {/* <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      onClick={() => setOpen(false)}
                      className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    >
                      Deactivate
                    </button>
                    <button
                      type="button"
                      data-autofocus
                      onClick={() => setOpen(false)}
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    >
                      Cancel
                    </button>
                  </div> */}
                </DialogPanel>
              </div>
            </div>
          </Dialog>

          {/* <Dialog open={openMap} onClose={setOpenMap} className="relative z-20">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <div style={{ height: '70vh', width: '100%' }}>
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: "AIzaSyDIz3QGrrutmfxrRrYG7j4HAQ0By581Tgs" }}
                      defaultCenter={defaultProps.center}
                      defaultZoom={defaultProps.zoom}
                    >
                      <AnyReactComponent
                        lat={59.955413}
                        lng={30.337844}
                        text="My Marker"
                      />
                    </GoogleMapReact>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog> */}
        </section>
    );
  }
  
  export default Post;
  

